import { useMemo } from 'react';

import { isNonEnglish } from 'src/data/generation';
import { TEXT_DETAILS_PANEL_TAB } from 'src/data/ui';
import * as events from 'src/lib/events';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { UiStore, useUiActions } from 'src/store';

import { useTrackingEvent } from '../useTrackingEvent';

const useUiState = createStateSelectorHook(UiStore, ['textDetailsPanelTab']);

export const useTabProps = ({ language, isFreestyleTool }) => {
  const uiActions = useUiActions();
  const { textDetailsPanelTab } = useUiState();
  const trackEvent = useTrackingEvent();
  const showTabs = !isNonEnglish(language) && !isFreestyleTool;

  return useMemo(() => {
    const handleSelectTab = (event, newTab) => {
      trackEvent(events.DOCUMENT.insightsPanelTabChanged, {
        page: events.EVENT_PAGE.editor,
        tab: newTab,
      });
      uiActions.setTextDetailsPanelTab(newTab);
    };

    const selectedTab = showTabs ? textDetailsPanelTab : TEXT_DETAILS_PANEL_TAB.brandPolicy;
    const availableTabs = showTabs
      ? [TEXT_DETAILS_PANEL_TAB.performance, TEXT_DETAILS_PANEL_TAB.brandPolicy]
      : [TEXT_DETAILS_PANEL_TAB.brandPolicy];

    return {
      showTabs,
      onSelectTab: handleSelectTab,
      selectedTab,
      availableTabs,
    };
  }, [textDetailsPanelTab, uiActions, trackEvent, showTabs]);
};
